/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GeoTestScheduleDTO { 
    /**
     * Test start date in ISO-8601 format
     */
    startDate: string;
    /**
     * Test end date in ISO-8601 format
     */
    endDate: string;
    /**
     * Test duration in weeks
     */
    testLength: number;
    /**
     * Type of geo test (incrementality or scale)
     */
    testType: GeoTestScheduleDTO.TestTypeEnum;
    /**
     * Minimum detectable effect (MDE) threshold for the test
     */
    mde: number;
    /**
     * Inventory reference period start date in ISO-8601 format
     */
    inventoryRefStartDate?: string;
    /**
     * Inventory reference period end date in ISO-8601 format
     */
    inventoryRefEndDate?: string;
}
export namespace GeoTestScheduleDTO {
    export type TestTypeEnum = 'Holdout' | 'Scale' | 'Contribution';
    export const TestTypeEnum = {
        Holdout: 'Holdout' as TestTypeEnum,
        Scale: 'Scale' as TestTypeEnum,
        Contribution: 'Contribution' as TestTypeEnum
    };
}


